/**
 * A reference to the host's intrinsic {@link Error} implementation.
 *
 * @remarks
 * This should be preferred instead of direct references to {@link Error}.
 */
export const NativeError = Error;
//# sourceMappingURL=native-error.const.mjs.map